import React from 'react'
import { Illustrations } from '../../../new-components/atoms'
import { Icons } from '../../../new-components/atoms'

interface Screen1Props {
  onGenerateDocument: () => void
  loading: boolean
  onClose: () => void
}

const Screen1: React.FC<Screen1Props> = ({ onGenerateDocument, loading, onClose }) => {
  return (
    <div
      style={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
      }}>
      {/* Header */}
      <div
        className="header-section"
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: '32px',
          backgroundColor: '#fff',
          borderBottom: '1px solid #E3E3E3',
          padding: '24px',
        }}>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '8px'
          }}>
          <div
            style={{
              width: '24px',
              height: '24px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}>
            <Icons.ShoppingBag 
              width="34"
              height="34"
              color="#6B7B3C"
            />
          </div>
          <h2
            className="header-title"
            style={{
              fontSize: '1.25rem',
              fontWeight: '600',
              color: '#6B7B3C',
              margin: 0
            }}>
            Cannect cuida por você
          </h2>
        </div>
        <button
          onClick={onClose}
          style={{
            background: 'none',
            border: 'none',
            fontSize: '1.5rem',
            color: '#6b7280',
            cursor: 'pointer',
            padding: '4px',
            borderRadius: '4px',
            transition: 'color 0.2s',
          }}>
          ×
        </button>
      </div>

      {/* Content */}
      <div className="content-section" style={{ flex: 1, display: 'flex', flexDirection: 'column', padding: '0 24px 24px 24px' }}>
        {/* Explanation */}
        <p
          className="explanation-text"
          style={{
            color: '#374151',
            fontSize: '16px',
            lineHeight: '1.6',
            marginBottom: '32px',
            fontWeight: '600'
          }}>
          Envie a procuração e nós emitimos sua autorização de importação junto à Anvisa, com segurança e agilidade.
        </p>

        {/* Illustration */}
        <div
          className="illustration-container"
          style={{
            display: 'flex',
            justifyContent: 'center',
            marginBottom: '32px'
          }}>
          <div
            className="illustration-wrapper"
            style={{
              width: '320px',
              height: '320px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              position: 'relative'
            }}>
            <div
              style={{
                fontSize: '5rem',
                transform: 'scale(0.8)'
              }}>
              <Illustrations.RequestAnvisa 
                  width="320"
                  height="320"
              />
            </div>
          </div>
        </div>

        {/* Benefits */}
        <div className="benefits-section" style={{ marginBottom: '32px', marginTop: '32px' }}>
          <div
            style={{
              display: 'flex',
              alignItems: 'flex-start',
              gap: '12px',
              marginBottom: '16px'
            }}>
            <div
              style={{
                width: '20px',
                height: '20px',
                border: '2px solid #6B7B3C',
                borderRadius: '4px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0,
                marginTop: '2px'
              }}>
              <span style={{ color: '#6B7B3C', fontSize: '12px' }}>✓</span>
            </div>
            <p
              style={{
                color: '#374151',
                fontSize: '0.95rem',
                lineHeight: '1.5',
                margin: 0,
                fontWeight: '500'
              }}>
              Com a procuração assinada, a Cannect solicita a autorização por você, sem complicações.
            </p>
          </div>

          <div
            style={{
              display: 'flex',
              alignItems: 'flex-start',
              gap: '12px'
            }}>
            <div
              style={{
                width: '20px',
                height: '20px',
                border: '2px solid #6B7B3C',
                borderRadius: '4px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0,
                marginTop: '2px'
              }}>
              <span style={{ color: '#6B7B3C', fontSize: '12px' }}>✓</span>
            </div>
            <p
              style={{
                color: '#374151',
                fontSize: '0.95rem',
                lineHeight: '1.5',
                margin: 0,
                fontWeight: '500'
              }}>
              Você evita burocracias e segue com seu tratamento com tranquilidade.
            </p>
          </div>
        </div>
      </div>

      <div 
      className="button-section"
      style={{ padding: '0 24px 44px 24px' }}
      >
      <button
        onClick={onGenerateDocument}
        disabled={loading}
        style={{
          width: '100%',
          background: loading ? '#9ca3af' : '#748351',
          color: 'white',
          border: 'none',
          borderRadius: '4px',
          padding: '16px 24px',
          fontSize: '1rem',
          fontWeight: '600',
          cursor: loading ? 'not-allowed' : 'pointer',
          transition: 'background-color 0.2s',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '8px'
        }}>
        {loading ? (
          <>
            <div
              style={{
                width: '16px',
                height: '16px',
                border: '2px solid transparent',
                borderTop: '2px solid white',
                borderRadius: '50%',
                animation: 'spin 1s linear infinite'
              }}
            />
            Gerando...
          </>
        ) : (
          'Gerar procuração para assinatura'
        )}
      </button>
      </div>

      <style>{`
        @keyframes spin {
          0% {
            transform: rotate(0deg);
          }
          100% {
            transform: rotate(360deg);
          }
        }

        /* Estilos para desktop - garantir espaçamentos adequados */
        @media (min-width: 769px) {
          .header-section {
            padding: 24px !important;
            margin-bottom: 32px !important;
          }
          
          .content-section {
            padding: 0 24px 24px 24px !important;
          }
          
          .explanation-text {
            font-size: 16px !important;
            margin-bottom: 32px !important;
          }
          
          .illustration-container {
            margin-bottom: 32px !important;
          }
          
          .benefits-section {
            margin-bottom: 32px !important;
            margin-top: 32px !important;
          }
          
          .button-section {
            padding: 0 24px 44px 24px !important;
          }
        }

        @media (max-width: 768px) {
          .header-section {
            padding: 16px !important;
            margin-bottom: 24px !important;
          }
          
          .header-title {
            font-size: 1.1rem !important;
          }
          
          .content-section {
            padding: 0 16px 16px 16px !important;
          }
          
          .explanation-text {
            font-size: 14px !important;
            margin-bottom: 24px !important;
          }
          
          .illustration-container {
            margin-bottom: 24px !important;
          }
          
          .illustration-wrapper {
            width: 240px !important;
            height: 240px !important;
          }
          
          .benefits-section {
            margin-bottom: 32px !important;
            margin-top: 24px !important;
          }
          
          .button-section {
            padding: 0 16px 32px 16px !important;
          }
        }
        
        @media (max-width: 480px) {
          .header-section {
            padding: 12px !important;
            margin-bottom: 20px !important;
          }
          
          .header-title {
            font-size: 1rem !important;
          }
          
          .content-section {
            padding: 0 12px 12px 12px !important;
          }
          
          .explanation-text {
            font-size: 13px !important;
            margin-bottom: 20px !important;
          }
          
          .illustration-container {
            margin-bottom: 20px !important;
          }
          
          .illustration-wrapper {
            width: 200px !important;
            height: 200px !important;
          }
          
          .benefits-section {
            margin-bottom: 28px !important;
            margin-top: 20px !important;
          }
          
          .button-section {
            padding: 0 12px 24px 12px !important;
          }
        }
      `}</style>
    </div>
  )
}

export default Screen1
